import { createAction } from "@reduxjs/toolkit";
import type { UpdateEvents } from "../../types/event-updates";
import { KioskActions, type setStatePayload } from "./kiosk-types";

export const setKioskStage = createAction<setStatePayload>(
	KioskActions.SET_KIOSK_STAGE,
);

export const proxyKioskUpdate = createAction<UpdateEvents>(
	KioskActions.PROXY_KIOSK_UPDATE,
);

export const kioskQueuePlayback = createAction<any>(
	KioskActions.QUEUE_PLAYBACK,
);

export const kioskBatchQueuePlaybacks = createAction<any[]>(
	KioskActions.BATCH_QUEUE_PLAYBACKS,
);

export const kioskDequeuePlayback = createAction(KioskActions.DEQUEUE_PLAYBACK);

export const updatePlaylist = createAction<{
	playlist: string[];
	resetIndex?: boolean;
}>(KioskActions.UPDATE_PLAYLIST);

export const advancePlaylist = createAction(KioskActions.ADVANCE_PLAYLIST);
